import {memo} from "react";
import {Row, Col, Table} from "antd";
import {numberFormat} from "~/utils";

const MKT_SERVICE_LABELS = {
	'ads-google': 'QC Google',
	'ads-facebook': 'QC Facebook',
	'ads-tiktok': 'QC TikTok',
	'admin-facebook': 'QT Facebook',
	'admin-website': 'QT Website',
	'seo': 'SEO',
};

const money = (v) => numberFormat(v || 0) + 'đ';

//Lương + hoa hồng quản lý marketing (theo doanh số phòng)
function PayDetailManagerMarketing({items = {}}) {

	const m = items || {};
	const fees = m.groupServiceFees || {};

	const summary = [
		{id: 'revenue', label: 'Doanh số phòng (gồm +20% ngân sách Google)', value: m.groupRevenue},
		{id: 'base', label: 'Lương cơ bản quản lý (theo mốc doanh số phòng)', value: m.managerBase},
		{id: 'commission', label: 'Hoa hồng quản lý', value: m.managerCommission},
	];

	const summaryColumns = [
		{title: 'Khoản', dataIndex: 'label', key: 'label'},
		{title: 'Số tiền', dataIndex: 'value', key: 'value', width: '160px', align: 'right', render: (v) => <b>{money(v)}</b>},
	];

	const feeData = Object.entries(MKT_SERVICE_LABELS).map(([key, label]) => ({
		id: key,
		label: 'Phí dịch vụ ' + label + ' (toàn phòng)',
		value: fees[key] || 0,
	}));

	return (
		<div className="table-wrapper form">
			<div className="table-box">
				<p className="heading">Lương quản lý marketing</p>
				<Table columns={summaryColumns} rowKey="id" dataSource={summary} pagination={false} scroll={{x: 'max-content'}} />

				<p className="heading mt-2">Phí dịch vụ theo phòng (cơ sở tính hoa hồng quản lý)</p>
				<Table columns={summaryColumns} rowKey="id" dataSource={feeData} pagination={false} scroll={{x: 'max-content'}} />

				<Row gutter={10} className="mt-2">
					<Col className="gutter-row" md={16} span={24} lg={18}><b>TỔNG THƯỞNG QUẢN LÝ</b></Col>
					<Col className="gutter-row" md={8} span={24} lg={6}>
						<span className="color-red"><b style={{fontSize: '20px'}}>{numberFormat(m.total)}</b>đ</span>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default memo(PayDetailManagerMarketing);
